var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-coloringtype": "fill",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.515 2.013C17.798 2.28 22 6.65 22 12l-.014.515C21.718 17.798 17.35 22 12 22l-.515-.014a10 10 0 0 1-9.472-9.471L2 12C2 6.477 6.477 2 12 2zM12 3.5a8.5 8.5 0 1 0 .001 17.001A8.5 8.5 0 0 0 12 3.5m.756 14.5H11.26V9.5h1.496zM12 5.486a1.25 1.25 0 1 1-.001 2.502A1.25 1.25 0 0 1 12 5.486"
})));
export default SvgInfo;